import { Record as record } from 'immutable';

import { construct, fields } from '../../helpers/LinkMapper';


const defaults = {
    adminFeePerTicket: 0,
    adminFeePerOrder: 0
};

class AmendConfig extends record(defaults) {
    static fromJSON (json) {
        return construct(AmendConfig, json, {
            adminFeePerTicket: fields.number,
            adminFeePerOrder: fields.number
        });
    }
}

export default AmendConfig;
